import { Inject, Injectable, OpaqueToken } from "@angular/core";
import { JwtHttpClientService } from "../../http/jwt-http-client.service";
import { AbstractHttpService } from "../../http/abstract-http.service";
import { ConfigurationService } from "../../configuration/configuration.service";
import { ResourceModule } from "../resource.module";
/**
 * Generic service for performing an action on the server.
 *
 * The #ACTION_RESOURCE must be registered as a provider in the Angular dependency injection to specify the resource name.
 * This will form part of the URL path.
 *
 * Errors are returned as a #DataClientErrorMessage
 */
export class ActionService extends AbstractHttpService {
    /**
     * Constructs the service with a resource, Http service, and Error service.
     * The resource may be injected via the #ACTION_RESOURCE alias
     * @param http HTTP Service
     * @param configService
     * @param nameSpace NameSpace that forms part of the URL
     * @param actionNames Action names for the APP
     * @param resource Resource name that forms part of the URL
     * @param version Resource version that forms part of the URL
     */
    constructor(http, configService, nameSpace, actionNames, resource) {
        super();
        this.http = http;
        this.configService = configService;
        this.nameSpace = nameSpace;
        this.actionNames = actionNames;
        this.resource = resource;
        if (actionNames && actionNames.indexOf(resource) < 0) {
            throw new Error("Action " + resource + " is not supported.");
        }
        let url = ActionService.URL_PREFIX + nameSpace + "/" + resource;
        let version = this.getResourceVersion();
        if (version) {
            url = url + ".v" + version;
        }
        url = url + "/";
        this.url = url;
    }
    getNameSpace() {
        return this.nameSpace;
    }
    getResource() {
        return this.resource;
    }
    /**
     * Performs an action on the server
     * @param entityData
     * @returns {Promise<any>} JSON object representation of the action result
     */
    performAction(entityData) {
        return this.http.post(this.url, entityData.toJSONString ? entityData.toJSONString() : entityData)
            .map((response) => response.json() || {})
            .catch((response) => this.handleServiceError(response))
            .toPromise();
    }
    canPerformAction() {
        return this.configService.getString("resourcePrivilege/action/" + this.nameSpace + "/" + this.resource).then((privMask) => privMask ? this.configService.getBoolean("authorisation/" + privMask.replace("*", "perform")) : false);
    }
    static canPerformAction(configService, resource) {
        return configService.getString("resourcePrivilege/action/" + resource).then((privMask) => privMask ? configService.getBoolean("authorisation/" + privMask.replace("*", "perform")) : false);
    }
    /**
     * Returns the version of the resource.
     * @returns {number}
     */
    getResourceVersion() {
        return 0;
    }
}
/**
 * Static URL prefix for all server side request calls
 * @type {string}
 */
ActionService.URL_PREFIX = '/dataserver/action/';
/**
 * Provider lookup key alias that is used during dependency injection
 * @type {OpaqueToken}
 */
ActionService.ACTION_RESOURCE = new OpaqueToken('actionResource');
/**
 * Provider lookup key alias that is used during dependency injection
 * @type {OpaqueToken}
 */
ActionService.RESOURCE_VERSION = new OpaqueToken('resourceVersion');
ActionService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ActionService.ctorParameters = () => [
    { type: JwtHttpClientService, },
    { type: ConfigurationService, },
    { type: undefined, decorators: [{ type: Inject, args: [ResourceModule.RESOURCE_NAMESPACE_KEY,] },] },
    { type: Array, decorators: [{ type: Inject, args: [ResourceModule.ACTION_NAMES_KEY,] },] },
    { type: undefined, decorators: [{ type: Inject, args: [ActionService.ACTION_RESOURCE,] },] },
];
//# sourceMappingURL=action.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/resource/action/action.service.js
// module id = null
// module chunks = 